import styled from "styled-components"

export const StyledIframe = styled.iframe`
  border: 0;
`
